import { render, staticRenderFns } from "./TheAutocompleteTemplate.vue?vue&type=template&id=1bf5fb5d&"
import script from "./TheAutocompleteTemplate.vue?vue&type=script&lang=js&"
export * from "./TheAutocompleteTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Server\\domains\\localhost\\ss\\wa-apps\\shop\\plugins\\giftcertificates\\build\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf5fb5d')) {
      api.createRecord('1bf5fb5d', component.options)
    } else {
      api.reload('1bf5fb5d', component.options)
    }
    module.hot.accept("./TheAutocompleteTemplate.vue?vue&type=template&id=1bf5fb5d&", function () {
      api.rerender('1bf5fb5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/pages/marketing_item/TheAutocompleteTemplate.vue"
export default component.exports